<template>
  <h1 style="text-align: center; margin-top:150px">Page not found</h1>
</template>